export default "__VITE_ASSET__DebTnTem__"